import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEOHead from "@/components/seo/SEOHead";
import Brand from "@/components/ui/brand";
import { useTranslation } from "react-i18next";

/**
 * Erklärung zur Barrierefreiheit gemäß BFSG / BITV 2.0.
 */
const Barrierefreiheit = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEOHead
        title={t("barrierefreiheit.seoTitle")}
        description={t("barrierefreiheit.seoDesc")}
        canonical="/barrierefreiheit"
      />
      <Header />

      <main id="main-content" className="flex-1 pt-28 pb-20 section-padding">
        <div className="max-w-3xl mx-auto space-y-12">
          <h1 className="text-headline">{t("barrierefreiheit.title")}</h1>

          <section className="space-y-3">
            <h2 className="text-subheadline">{t("barrierefreiheit.scopeTitle")}</h2>
            <p className="text-caption leading-relaxed">
              {t("barrierefreiheit.scopeText")}{" "}
               <a href="https://www.craftfindus.com" className="text-accent hover:underline focus:underline focus:outline-none focus:ring-2 focus:ring-ring">
                 www.craftfindus.com
              </a>{" "}
              {t("barrierefreiheit.scopeSuffix")} <Brand />.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-subheadline">{t("barrierefreiheit.compatTitle")}</h2>
            <p className="text-caption leading-relaxed">
              {t("barrierefreiheit.compatText1")}
            </p>
            <p className="text-caption leading-relaxed">
              {t("barrierefreiheit.compatText2")}
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-subheadline">{t("barrierefreiheit.measuresTitle")}</h2>
            <ul className="space-y-2 text-caption leading-relaxed list-disc pl-5">
              <li>{t("barrierefreiheit.measure1")}</li>
              <li>{t("barrierefreiheit.measure2")}</li>
              <li>{t("barrierefreiheit.measure3")}</li>
              <li>{t("barrierefreiheit.measure4")}</li>
              <li>{t("barrierefreiheit.measure5")}</li>
              <li>{t("barrierefreiheit.measure6")}</li>
              <li>{t("barrierefreiheit.measure7")}</li>
              <li>{t("barrierefreiheit.measure8")}</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-subheadline">{t("barrierefreiheit.limitationsTitle")}</h2>
            <p className="text-caption leading-relaxed">
              {t("barrierefreiheit.limitationsIntro")}
            </p>
            <ul className="space-y-2 text-caption leading-relaxed list-disc pl-5">
              <li>{t("barrierefreiheit.limitation1")}</li>
              <li>{t("barrierefreiheit.limitation2")}</li>
            </ul>
            <p className="text-caption leading-relaxed">
              {t("barrierefreiheit.limitationsOutro")}
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-subheadline">{t("barrierefreiheit.feedbackTitle")}</h2>
            <p className="text-caption leading-relaxed">
              {t("barrierefreiheit.feedbackIntro")}
            </p>
            <p className="text-body">
              <Brand /><br />
              Alexander Wolfshohl<br />
              Mittelpilghausen 20<br />
              42657 Solingen<br />
              {t("common.phone")}: <a href="tel:+4921224355800" className="text-accent hover:underline focus:underline focus:outline-none focus:ring-2 focus:ring-ring">0212 24355800</a><br />
              {t("common.email")}: <a href="mailto:kontakt@craftfindus.de" className="text-accent hover:underline focus:underline focus:outline-none focus:ring-2 focus:ring-ring">kontakt@craftfindus.de</a>
            </p>
            <p className="text-caption leading-relaxed">
              {t("barrierefreiheit.feedbackResponse")}
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-subheadline">{t("barrierefreiheit.enforcementTitle")}</h2>
            <p className="text-caption leading-relaxed">
              {t("barrierefreiheit.enforcementText")}{" "}
              <a
                href="https://www.bmas.de"
                target="_blank"
                rel="noopener noreferrer"
                className="text-accent hover:underline focus:underline focus:outline-none focus:ring-2 focus:ring-ring"
              >
                {t("barrierefreiheit.enforcementLink")}
              </a>{" "}
              {t("barrierefreiheit.enforcementSuffix")}
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-subheadline">{t("barrierefreiheit.createdTitle")}</h2>
            <p className="text-caption leading-relaxed">
              {t("barrierefreiheit.createdText")}
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Barrierefreiheit;